import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "./shared/shared.module";
import { httpInterceptProviders } from "./core/interceptor";
import { PopoverModule } from "ngx-bootstrap/popover";
import { CustomToastComponent } from "./custom-toast/custom-toast.component";
// import { UserIdleModule } from "angular-user-idle";
// import { KatexModule } from 'ng-katex';

@NgModule({ declarations: [AppComponent, CustomToastComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        CommonModule,
        FormsModule,
        PopoverModule.forRoot(),
        SharedModule,
        BrowserAnimationsModule,
        // UserIdleModule.forRoot({ idle: 300, timeout: 150, ping: 60 }),
        ToastrModule.forRoot({
            timeOut: 2500,
            positionClass: "toast-top-center",
            preventDuplicates: true,
            countDuplicates: false,
            progressBar: true,
        })], providers: [httpInterceptProviders, DatePipe, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
